import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Navigate, Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import './App.css';
import './styles/poptin.css';
import './styles/hero.css';
import SEO from './components/SEO';
import './styles/promo-popup.css';
import GoogleTagManager from './components/GoogleTagManager';
import { GTM_ID } from './config/analytics';
import { trackEvent } from './utils/analytics';
import { generateToken, TOKEN_HEADER } from './utils/tokenUtils';
import Header from './components/Header';
import Footer from './components/Footer';
import PromoBanner from './components/PromoBanner';
import ArchitectProgram from './pages/ArchitectProgram';
import Fresher2Fullstack from './pages/Fresher2Fullstack';
import MentorProfile from './pages/MentorProfile';
import Cap from './pages/Cap';
import CopilotTraining from './pages/CopilotTraining';
import GH300 from './pages/GH300';
import CloudBundleAz900 from './pages/CloudBundleAz900';
import CloudBundleDp900 from './pages/CloudBundleDp900';
import CloudBundlePl900 from './pages/CloudBundlePl900';
import AgenticQA from './pages/AgenticQA';
//import CopilotB2B from './pages/CopilotB2B';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
 import Privacy from './pages/Privacy';
 import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Feedback from './pages/Feedback';
import EventFeedback from './pages/EventFeedback';
import EventSurvey from './pages/EventSurvey';
import SurveyDashboard from './pages/SurveyDashboard';
import Admin from './pages/Admin';
import Events from './pages/Events';
import EventDetails from './pages/EventDetails';
import WorkshopLogin from './pages/WorkshopLogin';
import Workshop from './pages/Workshop';
import WorkshopDetail from './pages/WorkshopDetail';
import Jobs from './pages/Jobs';
import Home from './pages/Home';
import Lms from './pages/Lms';
import Login from './pages/Login';
import Player from './pages/Player';
import CareerPlans from './pages/CareerPlans';
import Subscriptions from './pages/Subscriptions';
import IgniteOfferPopup from './components/subscriptions/IgniteOfferPopup';
import WebsiteFeedbackPopup from './components/WebsiteFeedbackPopup';
import Chatbot from './components/Chatbot';
// import Login from './components/Login';
// import Register from './components/Register';
// import Dashboard from './components/Dashboard';
import testimonials from './data/testimonials.json';
import programsData from './data/programs.json';
import agenticSDLCData from './data/agenticsdlc.json';
import { API_ENDPOINTS } from './config/constants';
  import TagManager from 'react-gtm-module';
     // Get recent 4 Copilot-related blogs
  const blogsData = require('./data/blogs.json').blogs;

  const copilotBlogs = blogsData
    .filter(b => b.title.toLowerCase().includes('copilot'))
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);
   // Initialize GTM with your GTM ID
const tagManagerArgs = {
  gtmId: 'AW-16782075468', // Replace this with your actual GTM ID
};

TagManager.initialize(tagManagerArgs);



function App() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [userLocation, setUserLocation] = useState('IN');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedProgramType, setSelectedProgramType] = useState('All');

  // Helper function to detect location from domain
  const getLocationFromDomain = () => {
    const hostname = window.location.hostname.toLowerCase();
    
    if (hostname.includes('leadwithtech.us')) {
      return 'US';
    } else if (hostname.includes('leadwithtech.com.au')) {
      return 'AU';
    } else if (hostname.includes('leadwithtech.co.uk')) {
      return 'UK';
    } else if (hostname.includes('leadwithtech.in') || hostname.includes('localhost')) {
      return 'IN';
    }
    
    // Default to IN
    return 'IN';
  };

  // Detect location from query string, sessionStorage, or domain on mount
  useEffect(() => {
    // Check for location query parameter
    const locationParam = searchParams.get('location') || searchParams.get('loc');
    
    if (locationParam) {
      // Save to sessionStorage and use it
      const upperLocation = locationParam.toUpperCase();
      sessionStorage.setItem('loc', upperLocation);
      setUserLocation(upperLocation);
    } else {
      // Check sessionStorage first
      const storedLocation = sessionStorage.getItem('loc');
      if (storedLocation) {
        setUserLocation(storedLocation);
      } else {
        // Fall back to domain-based detection
        const detectedLocation = getLocationFromDomain();
        sessionStorage.setItem('loc', detectedLocation);
        setUserLocation(detectedLocation);
      }
    }
  }, [searchParams]);

  // Helper function to get location-based pricing
  const getLocationPricing = (program) => {
    // Check if program has location-based pricing
    if (program.pricing && program.pricing.locations && program.pricing.locations[userLocation]) {
      return program.pricing.locations[userLocation];
    }
    // Check if program has homePagePricing with location-based pricing
    if (program.homePagePricing && program.homePagePricing.locations && program.homePagePricing.locations[userLocation]) {
      return program.homePagePricing.locations[userLocation];
    }
    // Fall back to default homePagePricing
    return program.homePagePricing || { current: 'N/A', original: 'N/A' };
  };

  // Helper function to append location query parameter to URLs (keeping for backward compatibility)
  const appendLocationParam = (url) => {
    // No longer appending location to URLs as it's domain-based now
    return url;
  };

  // Handle carousel autoplay
  // Handle carousel dot click
  const handleCarouselClick = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    // Update active class on carousel items
    const items = document.querySelectorAll('.carousel-item');
    const dots = document.querySelectorAll('.carousel-dot');
    
    items.forEach((item, index) => {
      if (index === currentSlide) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    dots.forEach((dot, index) => {
      if (index === currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }, [currentSlide]);

  const handleFormSubmit = (source) => {
    trackEvent({
      event: 'form_submit',
      category: 'Lead',
      label: source
    });
  };

  const handleCarouselFormSubmit = (carouselId) => {
    trackEvent({
      event: 'hero_form_submit',
      category: 'Lead',
      label: carouselId
    });
  };

  // Handle newsletter signup
  const handleNewsletterSubmit = async (email, name) => {
    try {
      const response = await fetch(API_ENDPOINTS.NEWSLETTER_SUBSCRIBE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: generateToken(),
        },
        body: JSON.stringify({ email, name })
      });

      const data = await response.json();
      
      if (response.ok) {
        // Track successful subscription
        trackEvent({
          event: 'newsletter_subscription',
          category: 'Lead',
          label: 'success'
        });
        alert('Thank you for subscribing to our newsletter!');
      } else {
        throw new Error(data.error || 'Failed to subscribe');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      // Track failed subscription
      trackEvent({
        event: 'newsletter_subscription',
        category: 'Lead',
        label: 'error'
      });
      alert('Sorry, there was an error subscribing to the newsletter. Please try again.');
    }
  };

function HomePage() {
  // Scroll-up chevron state
  const [showScrollUp, setShowScrollUp] = useState(false);
  const [selectedWorkshopTag, setSelectedWorkshopTag] = useState('All');
  const [selectedCourseTag, setSelectedCourseTag] = useState('All');
  const [selectedEventTag, setSelectedEventTag] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const programsPerPage = 12;
  
  // Get unique tags for each section
  const workshopTags = ['All', ...new Set(Object.values(programsData)
    .filter(p => p.type === 'Workshop' && p.IsEnabled !== false)
    .flatMap(p => p.tags || []))];
  
  const courseTags = ['All', ...new Set(Object.values(programsData)
    .filter(p => p.type === 'Course' && p.IsEnabled !== false)
    .flatMap(p => p.tags || []))];
  
  const eventTags = ['All', ...new Set(Object.values(programsData)
    .filter(p => p.type === 'Event' && p.IsEnabled !== false)
    .flatMap(p => p.tags || []))];

  const agenticTiles = [
    {
      title: 'Agentic Product Management',
      icon: 'PM',
      description: 'Align product goals, scope, and release priorities with AI-assisted planning, discovery, and decision workflows.'
    },
    {
      title: 'Agentic Development',
      icon: 'DEV',
      description: 'Accelerate implementation through context-aware coding prompts, guardrails, and role-specific engineering workflows.'
    },
    {
      title: 'Agentic QA',
      icon: 'QA',
      description: 'Turn testing into a disciplined system with structured prompts, scenario generation, and validation-first execution.'
    },
    {
      title: 'Agentic Deployment',
      icon: 'DEP',
      description: 'Reduce release friction using automated checks, deployment readiness gates, and controlled rollout practices.'
    },
    {
      title: 'Agentic Governance',
      icon: 'GOV',
      description: 'Enforce policy, compliance, and review standards with transparent controls across prompts, agents, and outputs.'
    },
    {
      title: 'Agentic Support',
      icon: 'SUP',
      description: 'Improve incident response and customer support with guided triage, knowledge workflows, and AI-assisted resolution.'
    },
    {
      title: 'Agentic FinOps',
      icon: 'FIN',
      description: 'Track and optimize cloud and AI spend using usage intelligence, cost guardrails, and proactive recommendations.'
    },
    {
      title: 'Agentic Observability',
      icon: 'OBS',
      description: 'Continuously observe quality signals, detect anomalies early, and trigger actionable feedback loops for teams.'
    }
  ];

  const defaultAgenticPricing = agenticSDLCData?.pricing || {
    workshopCost: 'Rs 14999',
    packagePrice: 'Rs 9999'
  };

  const pricedAgenticTiles = agenticTiles.map((tile) => {
    const modulePricing = agenticSDLCData?.modules?.[tile.title] || {};
    return {
      ...tile,
      image: modulePricing.image || '/images/icons/qa-agentic.svg',
      duration: modulePricing.duration || '6 hrs',
      workshopCost: modulePricing.workshopCost || defaultAgenticPricing.workshopCost,
      packagePrice: modulePricing.packagePrice || defaultAgenticPricing.packagePrice
    };
  });

  const renderAgenticWorkflowTile = (tile, index) => (
    <div className="program-card fade-in" style={{ animationDelay: `${index * 0.05}s` }}>
      <div className="program-image-wrapper">
        <img
          src={tile.image}
          alt={`${tile.title} workshop`}
          className="program-image"
        />
      </div>
      <div className="program-content" style={{ display: 'flex', flexDirection: 'column', minHeight: '300px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
          <div className="program-type-badge">Workshop</div>
          <div style={{
            width: '34px',
            height: '34px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #DB2C27 0%, #b82220 100%)',
            color: '#fff',
            fontSize: '0.72rem',
            fontWeight: 800,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {tile.icon}
          </div>
        </div>
        <h3>{tile.title}</h3>
        <p className="program-instructor" style={{ marginBottom: '0.6rem' }}>Duration: {tile.duration}</p>
        <p className="program-description" style={{ marginBottom: '1rem' }}>{tile.description}</p>
        <div style={{ marginTop: 'auto' }}>
          <div className="program-footer" style={{ alignItems: 'center' }}>
            <div className="program-pricing">
              <span className="current-price">{tile.packagePrice}</span>
              <span className="original-price">{tile.workshopCost}</span>
            </div>
            <span className="explore-button" style={{ pointerEvents: 'none', opacity: 0.95 }}>
              Module {index + 1}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
  
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY || document.documentElement.scrollTop;
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (pageHeight > 0 && scrolled > pageHeight * 0.10) {
        setShowScrollUp(true);
      } else {
        setShowScrollUp(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
    const navigate = useNavigate();
    const [showPromoPopup, setShowPromoPopup] = useState(false);
    const [showRSVPModal, setShowRSVPModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [rsvpFormData, setRSVPFormData] = useState({
      month: '',
      name: '',
      email: '',
      mobile: ''
    });
    
   

    const handlePromoClose = () => {
      setShowPromoPopup(false);
      trackEvent({
        event: 'promo_popup_closed',
        category: 'Engagement',
        label: 'copilot_workshop'
      });
    };

    const handlePromoClick = () => {
      navigate(appendLocationParam('/copilot'));
      setShowPromoPopup(false);
      trackEvent({
        event: 'promo_popup_clicked',
        category: 'Engagement',
        label: 'copilot_workshop'
      });
    };
    
    const handleProgramClick = (programName) => {
      trackEvent({
        event: 'program_click',
        category: 'Engagement',
        label: programName
      });
    };

    const handleRSVPClick = (event) => {
      setSelectedEvent(event);
      setShowRSVPModal(true);
      trackEvent({
        event: 'rsvp_click',
        category: 'Engagement',
        label: event.title
      });
    };

    const handleRSVPClose = () => {
      setShowRSVPModal(false);
      setSelectedEvent(null);
      setRSVPFormData({
        month: '',
        name: '',
        email: '',
        mobile: ''
      });
    };

    const handleRSVPSubmit = async (e) => {
      e.preventDefault();
      
      try {
        const response = await fetch(API_ENDPOINTS.LEADS_CREATE, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            [TOKEN_HEADER]: generateToken(),
          },
          body: JSON.stringify({
            name: rsvpFormData.name,
            email: rsvpFormData.email,
            mobile: rsvpFormData.mobile,
            source: 'event_rsvp',
            interestedIn: selectedEvent?.id || 'event',
            consent: true,
            metadata: {
              eventTitle: selectedEvent?.title,
              preferredMonth: rsvpFormData.month
            }
          })
        });

        const data = await response.json();
        
        if (response.ok && data.success) {
          trackEvent({
            event: 'rsvp_submit',
            category: 'Lead',
            label: selectedEvent?.title
          });
          alert(`Thank you for your RSVP! We'll contact you soon about the ${selectedEvent?.title} event.`);
          handleRSVPClose();
        } else {
          throw new Error(data.message || 'Failed to submit RSVP');
        }
      } catch (error) {
        console.error('RSVP submission error:', error);
        alert('Sorry, there was an error submitting your RSVP. Please try again.');
      }
    };

  return (
  <>
      <SEO pageName="home" />
  <section className="hero-section" style={{ position: 'relative', backgroundImage: 'url(/images/background.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', width: '100%' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', zIndex: 1 }}></div>
        <div className="carousel" style={{ position: 'relative', zIndex: 2 }}>
          {/* Carousel Item 1 */}
          <div className="carousel-item active">
            <div className="hero-content fade-in">
              <h1>Empowering Engineers To Innovate, Inspire, And Lead The Future</h1>
              <p style={{ marginBottom: '1.2rem' }}>
                Guiding software professionals to grow into impactful tech leaders, forward-thinking architects, and AI-powered developers
              </p>
              <button
                type="button"
                className="button"
                onClick={() => {
                  navigate(appendLocationParam('/architect'));
                  trackEvent({
                    event: 'button_click',
                    category: 'Navigation',
                    label: 'hero_tell_me_more_architect'
                  });
                }}
              >
                Tell Me More
              </button>
            </div>
          </div>
          <div className="fade-in" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 700, 
              color: '#ffffff',
              marginBottom: '1rem'
            }}>
              Are You Ready to Evolve?
            </h2>
            <p style={{   
              fontSize: '1.25rem', 
              color: '#ffffff',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              We don't just teach code. We teach the mindset required to lead.
            </p>
          </div>

         
        </div>
      </section>

      <section className="features-section">
        <div className="features-title fade-in">
          <h2>Your Journey to Tech <span className="highlight">Leadership</span> Starts Here</h2>
        </div>
        
        <div className="features-grid">
          <div className="feature-card fade-in">
            <img 
              src="images/Industry-Mentors-1.png" 
              alt="Mentorship illustration" 
              className="feature-image"
            />
            <h3>Mentorship That Transforms Careers</h3>
            <p>Gain direct access to experienced industry mentors — professionals with over a decade of proven success — dedicated to helping you grow into a confident tech leader</p>
          </div>
          
          <div className="feature-card fade-in" style={{ animationDelay: '0.2s' }}>
            <img 
              src="/images/Project-based.png" 
              alt="Learning illustration" 
              className="feature-image"
            />
            <h3>Learn by Building. Grow by Achieving</h3>
            <p>Experience project-based, results-driven learning that turns theory into impact. Build real-world skills, sharpen critical thinking, and create outcomes that accelerate your career success</p>
          </div>
          
          <div className="feature-card fade-in" style={{ animationDelay: '0.4s' }}>
            <img 
              src="/images/Programs-aligned.png" 
              alt="Career growth illustration" 
              className="feature-image"
            />
            <h3>Your Next Role Starts Here</h3>
            <p>Advance through programs built for real career impact — aligned with evolving tech roles, empowering you to grow faster, lead stronger, and rise higher in your journey</p>
          </div>
        </div>
        
   
      </section>
      

  {/* Aspirational Career Authoring Program Section */}
  <section className="career-authoring-section" style={{
    padding: '4.5rem 0 4rem 0',
    background: 'linear-gradient(100deg, #fff 0%, #f5f7fa 100%)',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  }}>
    <div className="container fade-in" style={{ maxWidth: 820, margin: '0 auto', position: 'relative', zIndex: 2 }}>
      <h2 style={{
        fontSize: '2.7rem',
        fontWeight: 800,
        marginBottom: '1.1rem',
        color: '#DB2C27',
        letterSpacing: '-1px',
        textShadow: '0 2px 16px rgba(219,44,39,0.08)'
      }}>
        Career Authoring Program
      </h2>
      <h3 style={{
        fontSize: '1.45rem',
        fontWeight: 600,
        marginBottom: '1.5rem',
        color: '#1a1a1a',
        lineHeight: 1.4,
        letterSpacing: '-0.5px',
      }}>
        Your career will not grow automatically in the age of AI.<br />
        <span style={{ color: '#b82220', fontWeight: 700 }}>Build it intentionally. Author it strategically.</span>
      </h3>
      <p style={{
        fontSize: '1.18rem',
        marginBottom: '2.5rem',
        color: '#444',
        maxWidth: 650,
        marginLeft: 'auto',
        marginRight: 'auto',
        lineHeight: 1.7,
      }}>
        Join a new kind of career journey—one where you don’t just adapt to the future, you help shape it. Accelerate toward future-ready roles with structure, mentorship, and AI-enabled growth. <span style={{ color: '#DB2C27', fontWeight: 600 }}>Author your own success story.</span>
      </p>

      {/* Aspirational Tiles */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '2.5rem',
        margin: '2.5rem 0 2.7rem 0',
        flexWrap: 'wrap',
      }}>
        {/* Tile 1 */}
        <div style={{
          background: '#fff',
          borderRadius: '18px',
          boxShadow: '0 2px 16px rgba(219,44,39,0.07)',
          padding: '2.2rem 2.5rem 2rem 2.5rem',
          minWidth: '260px',
          maxWidth: '320px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transition: 'box-shadow 0.2s',
        }}>
          <div style={{
            width: 62,
            height: 62,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #DB2C27 0%, #b82220 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.1rem',
            boxShadow: '0 2px 12px rgba(219,44,39,0.10)',
          }}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="7" y="7" width="18" height="18" rx="5" fill="#fff"/>
              <path d="M13 19L16 22L21 15" stroke="#DB2C27" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div style={{ fontWeight: 700, fontSize: '1.18rem', color: '#b82220', textAlign: 'center' }}>Build it intentionally.</div>
        </div>
        {/* Tile 2 */}
        <div style={{
          background: '#fff',
          borderRadius: '18px',
          boxShadow: '0 2px 16px rgba(219,44,39,0.07)',
          padding: '2.2rem 2.5rem 2rem 2.5rem',
          minWidth: '260px',
          maxWidth: '320px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transition: 'box-shadow 0.2s',
        }}>
          <div style={{
            width: 62,
            height: 62,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #DB2C27 0%, #b82220 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.1rem',
            boxShadow: '0 2px 12px rgba(219,44,39,0.10)',
          }}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="7" y="7" width="18" height="18" rx="5" fill="#fff"/>
              <path d="M13 19L16 22L21 15" stroke="#DB2C27" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div style={{ fontWeight: 700, fontSize: '1.18rem', color: '#b82220', textAlign: 'center' }}>Author it strategically.</div>
        </div>
      </div>

      <Link to="/career-authoring-program" className="cta-button" style={{
        display: 'inline-block',
        background: 'linear-gradient(90deg, #DB2C27 0%, #b82220 100%)',
        color: '#fff',
        fontWeight: 700,
        fontSize: '1.18rem',
        padding: '15px 44px',
        borderRadius: '32px',
        textDecoration: 'none',
        boxShadow: '0 4px 18px rgba(219,44,39,0.10)',
        transition: 'background 0.2s',
        marginTop: '0.5rem',
      }}>
        Start Your Career Journey
      </Link>
    </div>
    {/* Decorative background shapes for aspiration */}
    <div style={{
      position: 'absolute',
      top: '-80px',
      left: '-120px',
      width: '320px',
      height: '320px',
      background: 'radial-gradient(circle, #ffe5e3 0%, rgba(255,255,255,0) 80%)',
      zIndex: 1,
      borderRadius: '50%'
    }} />
    <div style={{
      position: 'absolute',
      bottom: '-60px',
      right: '-100px',
      width: '220px',
      height: '220px',
      background: 'radial-gradient(circle, #fbeeea 0%, rgba(255,255,255,0) 80%)',
      zIndex: 1,
      borderRadius: '50%'
    }} />
  </section>

  <main id="programs" className="programs-section">
        <div className="programs-header fade-in">
          <h2>Our Flagship <span className="highlight">Mentor-Led Programs</span></h2>
          <p>Upskill with real-world experience and career-focused mentorship</p>
        </div>
        
        <div className="programs-tags-filter" style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '2rem', flexWrap: 'wrap' }}>
          {workshopTags.map(tag => (
            <button
              key={tag}
              onClick={() => setSelectedWorkshopTag(tag)}
              style={{
                padding: '8px 20px',
                borderRadius: '20px',
                border: '2px solid #DA291C',
                background: selectedWorkshopTag === tag ? '#DA291C' : '#fff',
                color: selectedWorkshopTag === tag ? '#fff' : '#DA291C',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              {tag}
            </button>
          ))}
        </div>
        
        <div className="programs-grid">
          {Object.values(programsData)
            .filter(program => program.type === 'Workshop' && program.IsEnabled !== false)
            .filter(program => selectedWorkshopTag === 'All' || (program.tags && program.tags.includes(selectedWorkshopTag)))
            .map((program, index) => (
            <div key={program.id} className="program-card">
              <div className="program-image-wrapper">
                <img 
                  src={program.image} 
                  alt={`${program.title} Icon`}
                  className="program-image"
                />
              </div>
              <div className="program-content">
                <div className="program-type-badge">{program.type}</div>
                <div className="program-badge">{program.badge}</div>
                <h3>{program.title}</h3>
                <p className="program-instructor">{program.instructor}</p>
                <div className="program-rating">
                  <span className="rating-stars">★</span>
                  <span className="rating-value">{program.rating.value}</span>
                </div>
                <p className="program-description">
                  {program.shortDescription}
                </p>
                <div className="program-footer">
                  <div className="program-pricing">
                    <span className="current-price">{getLocationPricing(program).current}</span>
                    <span className="original-price">{getLocationPricing(program).original}</span>
                  </div>
                  <Link 
                    to={appendLocationParam(program.ctaButton.link)} 
                    className="explore-button" 
                    onClick={() => { gtag_report_conversion(); handleProgramClick(program.title); }}
                  >
                    {program.ctaButton.text}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Agentic QA Section */}
      <section className="agentic-qa-section fade-in" style={{
        padding: '4.5rem 2rem',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e3e8ee 100%)',
        borderTop: '2px solid #e9ecef',
        borderBottom: '2px solid #e9ecef',
        margin: '0 0 3rem 0',
        position: 'relative',
        overflow: 'hidden',
        zIndex: 2
      }}>
        {/* Abstract AI+QA Icon/Visual */}
        <div style={{
          position: 'absolute',
          top: '-60px',
          right: '-60px',
          width: '180px',
          height: '180px',
          opacity: 0.13,
          zIndex: 0
        }}>
          <img src="/images/icons/ai-qa-abstract.png" alt="AI QA Abstract" style={{ width: '100%', height: '100%' }} />
        </div>
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div className="programs-header fade-in" style={{ marginBottom: '2rem' }}>
            <h2>Agentic SDLC <span className="highlight">Vibe Engineering Package</span></h2>
            <p>Choose from 8 mentor-led workshop modules. Each module includes a discounted package price for the complete journey.</p>
          </div>

          <div className="programs-grid">
            {pricedAgenticTiles.map((tile, index) => renderAgenticWorkflowTile(tile, index))}
          </div>

          <div style={{
            width: '100%',
            background: 'linear-gradient(90deg, #DB2C27 0%, #b82220 100%)',
            color: '#fff',
            borderRadius: '10px',
            padding: '0.95rem 1.1rem',
            textAlign: 'center',
            fontSize: '1.05rem',
            fontWeight: 800,
            letterSpacing: '0.2px',
            margin: '1.5rem 0 1rem',
            boxShadow: '0 6px 18px rgba(218,41,28,0.2)'
          }}>
            Agentic SDLC - Vibe Engineering Package | Workshop Cost: {defaultAgenticPricing.workshopCost} per module | Discounted Package: {defaultAgenticPricing.packagePrice} per module
          </div>

          <div style={{ textAlign: 'center' }}>
            <Link
              to={appendLocationParam('/agentic-qa')}
              className="button"
              style={{
                background: '#DB2C27',
                color: '#fff',
                padding: '14px 32px',
                borderRadius: '6px',
                fontWeight: 700,
                fontSize: '1.08rem',
                textDecoration: 'none',
                display: 'inline-block',
                boxShadow: '0 2px 12px rgba(218,41,28,0.10)',
                transition: 'background 0.2s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#b82220'}
              onMouseLeave={e => e.currentTarget.style.background = '#DB2C27'}
              onClick={() => trackEvent({ category: 'Engagement', action: 'CTA Click', label: 'agentic_qa_learn_more' })}
            >
              Explore Full Agentic SDLC Syllabus &rarr;
            </Link>
          </div>
        </div>
      </section>

      {/* Vibe Engineering Program Section */}
      <section style={{
        padding: '5rem 2rem',
        background: '#274152',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Subtle radial glow */}
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
          height: '100%',
          background: 'radial-gradient(circle at 80% 50%, rgba(219,44,39,0.08) 0%, transparent 55%)',
          pointerEvents: 'none'
        }} />

        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '3rem',
            alignItems: 'center'
          }}>

            {/* Left Column */}
            <div className="fade-in">
              {/* TRENDING NOW badge */}
              <div style={{
                display: 'inline-block',
                background: '#DB2C27',
                color: '#fff',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                padding: '6px 14px',
                borderRadius: '20px',
                marginBottom: '1.5rem',
                textTransform: 'uppercase'
              }}>
                TRENDING NOW
              </div>

              {/* Headline */}
              <h2 style={{
                fontSize: '2.25rem',
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: '1rem',
                color: '#fff'
              }}>
                Vibe Coding Gets You Started.<br />
                <span style={{ color: '#DB2C27' }}>Vibe Engineering</span> Gets You Shipped.
              </h2>

              {/* Subheading */}
              <p style={{
                fontSize: '1.1rem',
                fontWeight: 600,
                color: '#e0e8ee',
                marginBottom: '1rem',
                lineHeight: 1.5
              }}>
                Everyone is using AI to write code fast.<br />
                Almost no one is engineering with it.
              </p>

              {/* Body copy */}
              <p style={{
                fontSize: '1rem',
                color: '#b0c4d4',
                lineHeight: 1.75,
                marginBottom: '2rem'
              }}>
                Vibe Coding is the creative, flow-state energy that lets you build faster than ever.
                But without engineering discipline underneath it, AI-generated code breaks the moment
                it hits production — security gaps, hallucinated APIs, technical debt that compounds overnight.
                <br /><br />
                <strong style={{ color: '#e0e8ee' }}>Vibe Engineering</strong> is the structured layer that makes the output actually ship.
                Context Engineering, Prompt Engineering, AI code review, and the 5W Framework.
              </p>

              {/* CTAs */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'flex-start' }}>
                <Link
                  to={appendLocationParam('/vibe-engineering')}
                  className="button"
                  style={{
                    background: '#DB2C27',
                    color: '#fff',
                    padding: '14px 28px',
                    borderRadius: '6px',
                    fontWeight: 700,
                    fontSize: '1rem',
                    textDecoration: 'none',
                    display: 'inline-block',
                    transition: 'background 0.2s ease'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#b82220'}
                  onMouseLeave={e => e.currentTarget.style.background = '#DB2C27'}
                  onClick={() => trackEvent({ category: 'Engagement', action: 'CTA Click', label: 'vibe_engineering_learn' })}
                >
                  Learn Vibe Engineering →
                </Link>
                <Link
                  to={appendLocationParam('/copilot')}
                  style={{
                    color: '#b0c4d4',
                    fontSize: '0.95rem',
                    textDecoration: 'underline',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                  onMouseLeave={e => e.currentTarget.style.color = '#b0c4d4'}
                >
                  Developer Productivity Masterclass →
                </Link>
              </div>
            </div>

            {/* Right Column — Feature Cards */}
            <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

              {/* Card 1 — Context Engineering */}
              <div style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'border-color 0.3s ease, background 0.3s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(219,44,39,0.08)';
                e.currentTarget.style.borderColor = 'rgba(219,44,39,0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
              }}>
                <div style={{ fontSize: '1rem', fontWeight: 700, color: '#DB2C27', marginBottom: '0.6rem' }}>
                  Context Engineering
                </div>
                <p style={{ fontSize: '0.9rem', color: '#b0c4d4', lineHeight: 1.65, margin: 0 }}>
                  Stop writing vague prompts. Learn to give AI the Technical, Enterprise, Domain, and Scope
                  context that produces production-ready output on the first pass.
                </p>
              </div>

              {/* Card 2 — AI Code Review */}
              <div style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'border-color 0.3s ease, background 0.3s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(219,44,39,0.08)';
                e.currentTarget.style.borderColor = 'rgba(219,44,39,0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
              }}>
                <div style={{ fontSize: '1rem', fontWeight: 700, color: '#DB2C27', marginBottom: '0.6rem' }}>
                  AI Code Review
                </div>
                <p style={{ fontSize: '0.9rem', color: '#b0c4d4', lineHeight: 1.65, margin: 0 }}>
                  A 5-step checklist for reviewing AI-generated code before it goes live.
                  Catch what the model misses — every time.
                </p>
              </div>

              {/* Card 3 — The Vibe Sprint */}
              <div style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'border-color 0.3s ease, background 0.3s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(219,44,39,0.08)';
                e.currentTarget.style.borderColor = 'rgba(219,44,39,0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
              }}>
                <div style={{ fontSize: '1rem', fontWeight: 700, color: '#DB2C27', marginBottom: '0.6rem' }}>
                  The Vibe Sprint
                </div>
                <p style={{ fontSize: '0.9rem', color: '#b0c4d4', lineHeight: 1.65, margin: 0 }}>
                  A structured sprint workflow that combines creative flow-state coding with engineering
                  discipline. Idea to production-ready code without the chaos.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* The Aspiring Architect Spotlight Section */}
      <section className="architect-spotlight-section" style={{
        padding: '5rem 2rem',
        background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'radial-gradient(circle at 20% 50%, rgba(218,41,28,0.1) 0%, transparent 50%)',
          pointerEvents: 'none'
        }} />
        
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div className="fade-in" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: 700,
              color: '#fff',
              marginBottom: '1rem'
            }}>
              Stop Just Coding. Start Architecting.
            </h2>
            <p style={{
              fontSize: '1.25rem',
              color: '#ecf0f1',
              maxWidth: '900px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Most courses teach you patterns. We teach you a decision-making engine. Our proprietary <strong style={{ color: '#DA291C' }}>SPARK Framework</strong> gives you a structured approach to lead technical teams and design scalable systems without the guesswork.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '16px',
            padding: '3rem',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1.5rem',
              marginBottom: '2.5rem'
            }}>
              {/* S - Strategy */}
              <div className="fade-in" style={{
                background: '#fff',
                border: '2px solid #DA291C',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s ease',
                animationDelay: '0.1s',
                boxShadow: '0 4px 12px rgba(218, 41, 28, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(218, 41, 28, 0.3)';
                e.currentTarget.querySelector('div').style.color = '#fff';
                e.currentTarget.querySelector('p').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.1)';
                e.currentTarget.querySelector('div').style.color = '#DA291C';
                e.currentTarget.querySelector('p').style.color = '#2c3e50';
              }}>
                <div style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: '#DA291C',
                  marginBottom: '0.75rem',
                  transition: 'color 0.3s ease'
                }}>
                  S - Spot the Problem
                </div>
                <p style={{
                  fontSize: '1rem',
                  color: '#2c3e50',
                  lineHeight: '1.6',
                  margin: 0,
                  transition: 'color 0.3s ease'
                }}>
Uncover root causes across Business, Tech, & People.
                </p>
              </div>

              {/* P - Patterns */}
              <div className="fade-in" style={{
                background: '#fff',
                border: '2px solid #DA291C',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s ease',
                animationDelay: '0.2s',
                boxShadow: '0 4px 12px rgba(218, 41, 28, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(218, 41, 28, 0.3)';
                e.currentTarget.querySelector('div').style.color = '#fff';
                e.currentTarget.querySelector('p').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.1)';
                e.currentTarget.querySelector('div').style.color = '#DA291C';
                e.currentTarget.querySelector('p').style.color = '#2c3e50';
              }}>
                <div style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: '#DA291C',
                  marginBottom: '0.75rem',
                  transition: 'color 0.3s ease'
                }}>
                  P - Plan with Purpose
                </div>
                <p style={{
                  fontSize: '1rem',
                  color: '#2c3e50',
                  lineHeight: '1.6',
                  margin: 0,
                  transition: 'color 0.3s ease'
                }}>
            Define guiding principles and simplify complexity.                </p>
              </div>

              {/* A - Analysis */}
              <div className="fade-in" style={{
                background: '#fff',
                border: '2px solid #DA291C',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s ease',
                animationDelay: '0.3s',
                boxShadow: '0 4px 12px rgba(218, 41, 28, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(218, 41, 28, 0.3)';
                e.currentTarget.querySelector('div').style.color = '#fff';
                e.currentTarget.querySelector('p').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.1)';
                e.currentTarget.querySelector('div').style.color = '#DA291C';
                e.currentTarget.querySelector('p').style.color = '#2c3e50';
              }}>
                <div style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: '#DA291C',
                  marginBottom: '0.75rem',
                  transition: 'color 0.3s ease'
                }}>
                  A - Architect for Scale
                </div>
                <p style={{
                  fontSize: '1rem',
                  color: '#2c3e50',
                  lineHeight: '1.6',
                  margin: 0,
                  transition: 'color 0.3s ease'
                }}>
                  Design cohesive solutions (Structure, Clarity, Cohesion).
                </p>
              </div>

              {/* R - Roadmap */}
              <div className="fade-in" style={{
                background: '#fff',
                border: '2px solid #DA291C',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s ease',
                animationDelay: '0.4s',
                boxShadow: '0 4px 12px rgba(218, 41, 28, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(218, 41, 28, 0.3)';
                e.currentTarget.querySelector('div').style.color = '#fff';
                e.currentTarget.querySelector('p').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.1)';
                e.currentTarget.querySelector('div').style.color = '#DA291C';
                e.currentTarget.querySelector('p').style.color = '#2c3e50';
              }}>
                <div style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: '#DA291C',
                  marginBottom: '0.75rem',
                  transition: 'color 0.3s ease'
                }}>
                  R - Rally for Impact
                </div>
                <p style={{
                  fontSize: '1rem',
                  color: '#2c3e50',
                  lineHeight: '1.6',
                  margin: 0,
                  transition: 'color 0.3s ease'
                }}>
                 Drive consensus and govern your principles.
                </p>
              </div>

              {/* K - Knowledge */}
              <div className="fade-in" style={{
                background: '#fff',
                border: '2px solid #DA291C',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s ease',
                animationDelay: '0.5s',
                boxShadow: '0 4px 12px rgba(218, 41, 28, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(218, 41, 28, 0.3)';
                e.currentTarget.querySelector('div').style.color = '#fff';
                e.currentTarget.querySelector('p').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.1)';
                e.currentTarget.querySelector('div').style.color = '#DA291C';
                e.currentTarget.querySelector('p').style.color = '#2c3e50';
              }}>
                <div style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: '#DA291C',
                  marginBottom: '0.75rem',
                  transition: 'color 0.3s ease'
                }}>
                  KS - Keynote with a Story
                </div>
                <p style={{
                  fontSize: '1rem',
                  color: '#2c3e50',
                  lineHeight: '1.6',
                  margin: 0,
                  transition: 'color 0.3s ease'
                }}>
Sell your vision to stakeholders effectively                </p>
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link
                to={appendLocationParam('/architect')}
                className="button"
                onClick={() => {
                  gtag_report_conversion();
                  handleProgramClick('Aspiring Architect Syllabus');
                  trackEvent({
                    event: 'button_click',
                    category: 'Navigation',
                    label: 'architect_spotlight_syllabus'
                  });
                }}
                style={{
                  display: 'inline-block',
                  padding: '1rem 2.5rem',
                  background: '#DA291C',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(218, 41, 28, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#b81f14';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(218, 41, 28, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#DA291C';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(218, 41, 28, 0.3)';
                }}
              >
                View the Syllabus
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* GitHub Copilot ROI Section */}
      <section className="copilot-roi-section" style={{
        padding: '5rem 2rem',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        position: 'relative'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="fade-in" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{
              fontSize: '2.8rem',
              fontWeight: 700,
              color: '#DA291C',
              marginBottom: '1rem'
            }}>
              Code 55% Faster.
            </h2>
          </div>

          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '2.5rem',
            boxShadow: '0 4px 20px rgba(44,62,80,0.08)',
            marginBottom: '3rem'
          }}>
            <p style={{
              fontSize: '1.15rem',
              color: '#2c3e50',
              lineHeight: '1.8',
              textAlign: 'center',
              marginBottom: '0'
            }}>
              GitHub Copilot often fails because developers don't know how to ask. We teach you the <strong style={{ color: '#DA291C' }}>5W Framework for Context Engineering</strong>—a proven method to stop hallucinating code and start shipping features.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {/* Column 1: The WHO & WHAT */}
            <div className="fade-in" style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '2.5rem',
              boxShadow: '0 4px 20px rgba(44,62,80,0.08)',
              border: '2px solid #e9ecef',
              transition: 'all 0.3s ease',
              animationDelay: '0.1s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 8px 30px rgba(218,41,28,0.15)';
              e.currentTarget.style.borderColor = '#DA291C';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(44,62,80,0.08)';
              e.currentTarget.style.borderColor = '#e9ecef';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #DA291C 0%, #b81f14 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                boxShadow: '0 4px 15px rgba(218, 41, 28, 0.2)'
              }}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 10v20M20 30c-5.5 0-10-4.5-10-10s4.5-10 10-10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                  <circle cx="20" cy="20" r="3" fill="#fff" />
                </svg>
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                color: '#2c3e50',
                marginBottom: '1rem'
              }}>
                The WHO & WHAT
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.7',
                margin: 0
              }}>
                Don't just say "Write a function." Learn to define the Persona (Who) and the exact Constraint (What) to get production-ready code instantly.
              </p>
            </div>

            {/* Column 2: The WHERE & WHEN */}
            <div className="fade-in" style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '2.5rem',
              boxShadow: '0 4px 20px rgba(44,62,80,0.08)',
              border: '2px solid #e9ecef',
              transition: 'all 0.3s ease',
              animationDelay: '0.2s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 8px 30px rgba(218,41,28,0.15)';
              e.currentTarget.style.borderColor = '#DA291C';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(44,62,80,0.08)';
              e.currentTarget.style.borderColor = '#e9ecef';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #DA291C 0%, #b81f14 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                boxShadow: '0 4px 15px rgba(218, 41, 28, 0.2)'
              }}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 20h10M20 15v10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                  <rect x="8" y="8" width="24" height="24" stroke="#fff" strokeWidth="2.5" rx="4" fill="none" />
                </svg>
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                color: '#2c3e50',
                marginBottom: '1rem'
              }}>
                The WHERE & WHEN
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.7',
                margin: 0
              }}>
                Master the art of placement. Learn Where to place your cursor and When to provide context from other files to guide Copilot's logic.
              </p>
            </div>

            {/* Column 3: The WHY */}
            <div className="fade-in" style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '2.5rem',
              boxShadow: '0 4px 20px rgba(44,62,80,0.08)',
              border: '2px solid #e9ecef',
              transition: 'all 0.3s ease',
              animationDelay: '0.3s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 8px 30px rgba(218,41,28,0.15)';
              e.currentTarget.style.borderColor = '#DA291C';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(44,62,80,0.08)';
              e.currentTarget.style.borderColor = '#e9ecef';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #DA291C 0%, #b81f14 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                boxShadow: '0 4px 15px rgba(218, 41, 28, 0.2)'
              }}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="12" stroke="#fff" strokeWidth="2.5" fill="none" />
                  <path d="M20 14v6l4 4" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 700,
                color: '#2c3e50',
                marginBottom: '1rem'
              }}>
                The WHY
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.7',
                margin: 0
              }}>
                Understand the logic behind the suggestion. We teach you to verify the Why so you never blindly commit broken code.
              </p>
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Link
              to={appendLocationParam('/copilot')}
              className="button"
              onClick={() => {
                gtag_report_conversion();
                handleProgramClick('GitHub Copilot AI Journey');
                trackEvent({
                  event: 'button_click',
                  category: 'Navigation',
                  label: 'copilot_roi_start_journey'
                });
              }}
              style={{
                display: 'inline-block',
                padding: '1rem 2.5rem',
                background: '#DA291C',
                color: '#fff',
                borderRadius: '8px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textDecoration: 'none',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(218, 41, 28, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#b81f14';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(218, 41, 28, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#DA291C';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(218, 41, 28, 0.3)';
              }}
            >
              Start Your AI Journey
            </Link>
          </div>
        </div>
      </section>

      <section className="programs-section" style={{ paddingTop: '2rem', background: '#fff' }}>
        <div className="programs-header fade-in">
          <h2><span className="highlight">Get Started Now!</span></h2>
          <p>Self-paced learning paths designed for quick skill-building and certification prep</p>
        </div>
        
        <div className="programs-tags-filter" style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '2rem', flexWrap: 'wrap' }}>
          {courseTags.map(tag => (
            <button
              key={tag}
              onClick={() => setSelectedCourseTag(tag)}
              style={{
                padding: '8px 20px',
                borderRadius: '20px',
                border: '2px solid #DA291C',
                background: selectedCourseTag === tag ? '#DA291C' : '#fff',
                color: selectedCourseTag === tag ? '#fff' : '#DA291C',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              {tag}
            </button>
          ))}
        </div>
        
        <div className="programs-grid">
          {Object.values(programsData)
            .filter(program => program.type === 'Course' && program.IsEnabled !== false)
            .filter(program => selectedCourseTag === 'All' || (program.tags && program.tags.includes(selectedCourseTag)))
            .map((program, index) => (
            <div key={program.id} className="program-card">
              <div className="program-image-wrapper">
                <img 
                  src={program.image} 
                  alt={`${program.title} Icon`}
                  className="program-image"
                />
              </div>
              <div className="program-content">
                <div className="program-type-badge">{program.type}</div>
                <div className="program-badge">{program.badge}</div>
                <h3>{program.title}</h3>
                <p className="program-instructor">{program.instructor}</p>
                <div className="program-rating">
                  <span className="rating-stars">★</span>
                  <span className="rating-value">{program.rating.value}</span>
                </div>
                <p className="program-description">
                  {program.shortDescription}
                </p>
                <div className="program-footer">
                  <div className="program-pricing">
                    <span className="current-price">{getLocationPricing(program).current}</span>
                    <span className="original-price">{getLocationPricing(program).original}</span>
                  </div>
                  <Link 
                    to={appendLocationParam(program.ctaButton.link)} 
                    className="explore-button" 
                    onClick={() => { gtag_report_conversion(); handleProgramClick(program.title); }}
                  >
                    {program.ctaButton.text}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="programs-section" style={{ paddingTop: '2rem', background: '#f8f9fa', display: 'none' }}>
        <div className="programs-header fade-in">
          <h2>Upcoming <span className="highlight">Events</span></h2>
          <p>Join our live sessions and interactive events</p>
        </div>
        
        <div className="programs-grid">
          {Object.values(programsData)
            .filter(program => program.type === 'Event' && program.IsEnabled !== false)
            .map((program, index) => (
            <div key={program.id} className="program-card">
              <div className="program-image-wrapper">
                <img 
                  src={program.image} 
                  alt={`${program.title} Icon`}
                  className="program-image"
                />
              </div>
              <div className="program-content">
                <div className="program-type-badge">{program.type}</div>
                <div className="program-badge">{program.badge}</div>
                <h3>{program.title}</h3>
                <p className="program-instructor">{program.instructor}</p>
                <div className="program-rating">
                  <span className="rating-stars">★</span>
                  <span className="rating-value">{program.rating.value}</span>
                </div>
                <p className="program-description">
                  {program.shortDescription}
                </p>
                <div className="program-footer">
                  <div className="program-pricing">
                    <span className="current-price">{getLocationPricing(program).current}</span>
                    <span className="original-price">{getLocationPricing(program).original}</span>
                  </div>
                  <button
                    className="explore-button"
                    onClick={() => handleRSVPClick(program)}
                    style={{ border: 'none', cursor: 'pointer' }}
                  >
                    {program.ctaButton.text}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="programs-section" style={{ paddingTop: '2rem', display: 'none' }}>
        <div className="programs-header fade-in">
          <h2>All <span className="highlight">Programs</span></h2>
          <p>Explore our complete range of training and courses</p>
        </div>
        
        <div className="programs-grid">
          {(() => {
            const allPrograms = Object.values(programsData);
            const totalPages = Math.ceil(allPrograms.length / programsPerPage);
            const startIndex = (currentPage - 1) * programsPerPage;
            const endIndex = startIndex + programsPerPage;
            const currentPrograms = allPrograms.slice(startIndex, endIndex);
            
            return currentPrograms.map((program, index) => (
            <div key={program.id} className="program-card">
              <div className="program-image-wrapper">
                <img 
                  src={program.image} 
                  alt={`${program.title} Icon`}
                  className="program-image"
                />
              </div>
              <div className="program-content">
                <div className="program-type-badge">{program.type}</div>
                <div className="program-badge">{program.badge}</div>
                <h3>{program.title}</h3>
                <p className="program-instructor">{program.instructor}</p>
                <div className="program-rating">
                  <span className="rating-stars">★</span>
                  <span className="rating-value">{program.rating.value}</span>
                </div>
                <p className="program-description">
                  {program.shortDescription}
                </p>
                <div className="program-footer">
                  <div className="program-pricing">
                    <span className="current-price">{getLocationPricing(program).current}</span>
                    <span className="original-price">{getLocationPricing(program).original}</span>
                  </div>
                  <Link 
                    to={appendLocationParam(program.ctaButton.link)} 
                    className="explore-button" 
                    onClick={() => { gtag_report_conversion(); handleProgramClick(program.title); }}
                  >
                    {program.ctaButton.text}
                  </Link>
                </div>
              </div>
            </div>
            ));
          })()}
        </div>

        {/* Pagination Controls */}
        {(() => {
          const allPrograms = Object.values(programsData);
          const totalPages = Math.ceil(allPrograms.length / programsPerPage);
          
          if (totalPages <= 1) return null;
          
          return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginTop: '3rem', marginBottom: '2rem' }}>
              <button
                onClick={() => {
                  setCurrentPage(prev => Math.max(1, prev - 1));
                  document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth' });
                }}
                disabled={currentPage === 1}
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: '2px solid #DA291C',
                  background: currentPage === 1 ? '#f0f0f0' : '#fff',
                  color: currentPage === 1 ? '#999' : '#DA291C',
                  fontWeight: 600,
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: currentPage === 1 ? 0.5 : 1
                }}
              >
                ← Previous
              </button>
              
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                <button
                  key={page}
                  onClick={() => {
                    setCurrentPage(page);
                    document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '2px solid #DA291C',
                    background: currentPage === page ? '#DA291C' : '#fff',
                    color: currentPage === page ? '#fff' : '#DA291C',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    minWidth: '44px'
                  }}
                >
                  {page}
                </button>
              ))}
              
              <button
                onClick={() => {
                  setCurrentPage(prev => Math.min(totalPages, prev + 1));
                  document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth' });
                }}
                disabled={currentPage === totalPages}
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: '2px solid #DA291C',
                  background: currentPage === totalPages ? '#f0f0f0' : '#fff',
                  color: currentPage === totalPages ? '#999' : '#DA291C',
                  fontWeight: 600,
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: currentPage === totalPages ? 0.5 : 1
                }}
              >
                Next →
              </button>
            </div>
          );
        })()}

        <div className="programs-trust-banner fade-in">
          <div className="trust-item">
            <span className="trust-icon">★</span>
            Trusted by 500+ Professionals
          </div>
          <div className="trust-item">
            <span className="trust-icon">👥</span>
            Real Mentorship
          </div>
          <div className="trust-item">
            <span className="trust-icon">🔒</span>
            Secure Learning
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <h2>What Our Architects Say</h2>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              className="testimonial-card fade-in"
              style={{ animationDelay: `${i * 0.2}s` }}
            >
              <p>{t.quote}</p>
              <h4>{t.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* Recent Copilot Blogs Grid */}
      <section className="copilot-blogs-section" style={{ margin: '3rem 0' }}>
        <h2 style={{ textAlign: 'center', color: '#DA291C', fontWeight: 700, marginBottom: '2rem' }}>Read our Blogs</h2>
        <div className="copilot-blogs-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px', maxWidth: '1100px', margin: '0 auto' }}>
          {copilotBlogs.map(blog => (
            <div key={blog.id} className="copilot-blog-card" style={{ background: '#fff', borderRadius: '14px', boxShadow: '0 2px 12px rgba(44,62,80,0.08)', padding: '18px', display: 'flex', flexDirection: 'column', gap: '10px', minHeight: '120px', justifyContent: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '6px' }}>
                {blog.image && (
                  <img src={blog.image} alt={blog.title} style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '8px', background: '#eee' }} />
                )}
                <h3 style={{ fontWeight: 700, fontSize: '1.08rem', color: '#DA291C', margin: 0 }}>{blog.title}</h3>
                <a href={`/blog/${blog.id}`} style={{ marginLeft: 'auto', color: '#DA291C', fontWeight: 700, fontSize: '1.5rem', textDecoration: 'none', display: 'flex', alignItems: 'center' }} aria-label={`Read ${blog.title}`}>
                  &rarr;
                </a>
              </div>
             </div>
          ))}
        </div>
      </section>

      <section className="newsletter-section fade-in">
          <h2>Newsletter — Lead With Tech</h2>
          <p>Stay ahead on your path from coder to architect. Get practical tips, real-world solution design insights, and invites to free live sessions—straight to your inbox.</p>

          <section className="newsletter-steps-section" style={{ position: 'relative', backgroundImage: 'url(/images/steps-bg.png)', backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '18px', margin: '2rem 0', padding: '2.5rem 1rem' }}>
            <div className="newsletter-benefits-steps" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px', margin: '0' }}>
              <div className="newsletter-step-tile" style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 12px rgba(44,62,80,0.08)', padding: '28px 18px', textAlign: 'center', fontWeight: 500, position: 'relative', color: '#222' }}>
                <div style={{ position: 'absolute', top: '18px', left: '18px', width: '32px', height: '32px', background: '#DA291C', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', boxShadow: '0 2px 8px rgba(218,41,28,0.10)' }}>1</div>
                <div style={{ marginTop: '18px' }}>Actionable architecture patterns<br />and DevOps practices</div>
              </div>
              <div className="newsletter-step-tile" style={{ background: '#DA291C', borderRadius: '12px', boxShadow: '0 2px 12px rgba(44,62,80,0.08)', padding: '28px 18px', textAlign: 'center', fontWeight: 500, position: 'relative', color: '#fff' }}>
                <div style={{ position: 'absolute', top: '18px', left: '18px', width: '32px', height: '32px', background: '#fff', color: '#DA291C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', boxShadow: '0 2px 8px rgba(218,41,28,0.10)' }}>2</div>
                <div style={{ marginTop: '18px' }}>Mentorship guidance<br />and career frameworks</div>
              </div>
              <div className="newsletter-step-tile" style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 12px rgba(44,62,80,0.08)', padding: '28px 18px', textAlign: 'center', fontWeight: 500, position: 'relative', color: '#222' }}>
                <div style={{ position: 'absolute', top: '18px', left: '18px', width: '32px', height: '32px', background: '#DA291C', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', boxShadow: '0 2px 8px rgba(218,41,28,0.10)' }}>3</div>
                <div style={{ marginTop: '18px' }}>Hands-on exercises<br />and case studies</div>
              </div>
              <div className="newsletter-step-tile" style={{ background: '#DA291C', borderRadius: '12px', boxShadow: '0 2px 12px rgba(44,62,80,0.08)', padding: '28px 18px', textAlign: 'center', fontWeight: 500, position: 'relative', color: '#fff' }}>
                <div style={{ position: 'absolute', top: '18px', left: '18px', width: '32px', height: '32px', background: '#fff', color: '#DA291C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', boxShadow: '0 2px 8px rgba(218,41,28,0.10)' }}>4</div>
                <div style={{ marginTop: '18px' }}>Early access to workshops<br />and resources</div>
              </div>
            </div>
          </section>
        <form className="newsletter-form" onSubmit={(e) => {
          e.preventDefault();
          const email = e.target.querySelector('input[type="email"]').value;
          const name = e.target.querySelector('input[name="name"]').value;
          if (email && name) {
            handleNewsletterSubmit(email, name);
            e.target.querySelector('input[type="email"]').value = '';
            e.target.querySelector('input[name="name"]').value = '';
          }
        }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', maxWidth: '600px', margin: '0 auto 1rem auto' }}>
            <input 
              type="text"
              name="name"
              className="newsletter-input"
              placeholder="Enter your name"
              aria-label="Name"
              required
              style={{ flex: 1, minWidth: 0, boxSizing: 'border-box', height: '48px' }}
            />
            <input 
              type="email" 
              className="newsletter-input" 
              placeholder="Enter your email address"
              aria-label="Email address"
              required
              style={{ flex: 1, minWidth: 0, boxSizing: 'border-box', height: '48px' }}
            />
            <button
              type="submit"
              className="button"
              style={{ height: '48px', minWidth: '120px', padding: '0 1.5rem', fontWeight: 600, fontSize: '1rem', boxSizing: 'border-box' }}
            >
              Subscribe
            </button>
          </div>
        </form>
      </section>

      {/* RSVP Modal */}
      {showRSVPModal && selectedEvent && (
        <>
          <div className="modal-overlay" onClick={handleRSVPClose} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }} />
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '90vh',
            overflowY: 'auto',
            zIndex: 10000,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <div className="modal-header" style={{ marginBottom: '1.5rem', borderBottom: '2px solid #f0f0f0', paddingBottom: '1rem' }}>
              <h2 style={{ margin: 0, color: '#DA291C', fontSize: '1.5rem' }}>RSVP for Event</h2>
              <button onClick={handleRSVPClose} style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#666'
              }}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ marginBottom: '1.5rem', color: '#555', fontSize: '0.95rem' }}>
                <strong>{selectedEvent.title}</strong>
              </p>
              <form onSubmit={handleRSVPSubmit}>
                <div style={{ marginBottom: '1.25rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: 600, color: '#333' }}>
                    Preferred Month to Attend *
                  </label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem' }}>
                    {['January', 'February', 'March', 'April'].map((month) => (
                      <button
                        key={month}
                        type="button"
                        onClick={() => setRSVPFormData({ ...rsvpFormData, month })}
                        style={{
                          padding: '1rem',
                          borderRadius: '8px',
                          border: `2px solid ${rsvpFormData.month === month ? '#DA291C' : '#ddd'}`,
                          backgroundColor: rsvpFormData.month === month ? '#fff5f5' : '#fff',
                          fontSize: '1rem',
                          fontWeight: rsvpFormData.month === month ? 600 : 400,
                          color: rsvpFormData.month === month ? '#DA291C' : '#333',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          if (rsvpFormData.month !== month) {
                            e.currentTarget.style.borderColor = '#DA291C';
                            e.currentTarget.style.backgroundColor = '#ffebeb';
                            e.currentTarget.style.color = '#DA291C';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (rsvpFormData.month !== month) {
                            e.currentTarget.style.borderColor = '#ddd';
                            e.currentTarget.style.backgroundColor = '#fff';
                            e.currentTarget.style.color = '#333';
                          }
                        }}
                      >
                        {month}
                      </button>
                    ))}
                  </div>
                </div>
                
                <div style={{ marginBottom: '1.25rem' }}>
                  <label htmlFor="rsvp-name" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="rsvp-name"
                    value={rsvpFormData.name}
                    onChange={(e) => setRSVPFormData({ ...rsvpFormData, name: e.target.value })}
                    required
                    placeholder="Enter your full name"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      borderRadius: '6px',
                      border: '1px solid #ddd',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '1.25rem' }}>
                  <label htmlFor="rsvp-email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="rsvp-email"
                    value={rsvpFormData.email}
                    onChange={(e) => setRSVPFormData({ ...rsvpFormData, email: e.target.value })}
                    required
                    placeholder="Enter your email address"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      borderRadius: '6px',
                      border: '1px solid #ddd',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '1.5rem' }}>
                  <label htmlFor="rsvp-mobile" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>
                    Mobile Number *
                  </label>
                  <input
                    type="tel"
                    id="rsvp-mobile"
                    value={rsvpFormData.mobile}
                    onChange={(e) => setRSVPFormData({ ...rsvpFormData, mobile: e.target.value })}
                    required
                    placeholder="Enter your mobile number"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      borderRadius: '6px',
                      border: '1px solid #ddd',
                      fontSize: '1rem'
                    }}
                  />
                </div>
                
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={handleRSVPClose}
                    style={{
                      padding: '0.75rem 1.5rem',
                      borderRadius: '6px',
                      border: '2px solid #DA291C',
                      background: '#fff',
                      color: '#DA291C',
                      fontSize: '1rem',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{
                      padding: '0.75rem 1.5rem',
                      borderRadius: '6px',
                      border: 'none',
                      background: '#DA291C',
                      color: '#fff',
                      fontSize: '1rem',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Submit RSVP
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      {/* Promotional Popup */}
      {showPromoPopup && (
        <>
          <div className="promo-popup-overlay" onClick={handlePromoClose} />
          <div className="promo-popup">
            <button className="promo-popup-close" onClick={handlePromoClose}>×</button>
            <div className="promo-popup-content">
              <h2>Master GitHub Copilot Workshop</h2>
              <p>Transform Your Coding Efficiency with AI</p>
              
              <div className="promo-popup-date">
                Next Workshop: Nov 15, 2025
              </div>
              
              <div className="promo-popup-features">
                <div className="promo-popup-feature">
                  Live hands-on training with certified trainer
                </div>
                <div className="promo-popup-feature">
                  Real-world coding examples and best practices
                </div>
                <div className="promo-popup-feature">
                  Limited time offer: 60% off regular price
                </div>
                <div className="promo-popup-feature">
                  Certificate of completion included
                </div>
              </div>
              
              <div className="promo-popup-cta">
                <button onClick={handlePromoClick} className="promo-popup-button">
                  Save Your Spot Now
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Scroll Up Chevron */}
      {showScrollUp && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            right: '32px',
            bottom: '40px',
            zIndex: 1000,
            background: '#fff',
            border: '2px solid #DA291C',
            borderRadius: '50%',
            width: '54px',
            height: '54px',
            boxShadow: '0 2px 12px rgba(44,62,80,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'opacity 0.2s',
            opacity: 0.95
          }}
          aria-label="Scroll to top"
        >
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#fff" />
            <path d="M10 18l6-6 6 6" stroke="#DA291C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          </svg>
        </button>
      )}
      
      {/* Ask Chai Chatbot */}
      <Chatbot programsData={programsData} getLocationPricing={getLocationPricing} />
   
    </>
  );
}

function gtag_report_conversion(url) {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-16782075468',
      event_callback: function () {
        if (url) {
          window.location = url;
        }
      }
    });
    return false;
  }
  return true;
}

  // Check if current path is player (full-screen mode)
  const isFullScreenRoute = location.pathname === '/player';

  return (
    <div className="App">
  {/* GoogleTagManager moved to Footer */}
      {/* <PromoBanner /> */}
      {!isFullScreenRoute && <Header />}
      <Routes>
          <Route path="/know-your-mentor" element={<MentorProfile />} />
        <Route path="/architect" element={<ArchitectProgram />} />
        <Route path="/fresher2fullstack" element={<Fresher2Fullstack />} />
        <Route path="/agentic-qa" element={<AgenticQA />} />
        <Route path="/copilot" element={<CopilotTraining />} />
        <Route path="/gh300" element={<GH300 />} />
        <Route path="/cloud-bundle-az900" element={<CloudBundleAz900 />} />
        <Route path="/cloud-bundle-dp900" element={<CloudBundleDp900 />} />
        <Route path="/cloud-bundle-pl900" element={<CloudBundlePl900 />} />
        {/* <Route path="/corp" element={<CopilotB2B />} /> */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/details" element={<EventDetails />} />
        <Route path="/events/login" element={<WorkshopLogin />} />
        <Route path="/events/register" element={<WorkshopLogin />} />
        <Route path="/workshop" element={<Workshop />} />
        <Route path="/workshop/:workshopId" element={<WorkshopDetail />} />
        <Route path="/workshop/:workshopId/prompt-labs" element={<WorkshopDetail />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/lms" element={<Lms />} />
        <Route path="/player" element={<Player />} />
        <Route path="/careerplans" element={<CareerPlans />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        {/* <Route path="/login" element={<Login onLogin={() => window.location.href = '/dashboard'} />} /> */}
        {/* <Route path="/register" element={<Register onRegister={() => window.location.href = '/login'} />} /> */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}

        {/* Career Authoring Program route and redirect */}
        <Route path="/career-authoring" element={<Navigate to="/career-authoring-program" replace />} />
        <Route path="/career-authoring-program" element={<Cap />} />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/events/feedback" element={<EventFeedback />} />
        <Route path="/events/survey" element={<EventSurvey />} />
        <Route path="/events/survey/:id/take" element={<EventSurvey />} />
        <Route path="/events/surveydashboard" element={<SurveyDashboard />} />
        <Route path="/" element={<Home />} />
      </Routes>
      {!isFullScreenRoute && <Footer />}
      <IgniteOfferPopup />
      <WebsiteFeedbackPopup />
    </div>
  );
}

export default App;
